import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { useSelector } from 'react-redux';
import { ExperienceChangeType, ExperienceChangeTypeOptions } from '@apply/constants';

const styles = {
    buttonMarginRight: { marginRight: '10px' },
    buttonContainer: {
        textAlign: 'right',
        borderTop: '2px solid silver',
        padding: '10px 10px',
    },
    form: { paddingLeft: '5px', paddingTop: '10px' },
    formRow: { marginBottom: '0' },
};

export const ChangeReasonModal = ({ isOpen, onSubmit, onCancel }) => {
    const [changeTypeId, set_changeTypeId] = useState(2);
    const [notes, set_notes] = useState('Initial Review');

    const { firstName, lastName } = useSelector((state) => state.user);
    const userFullName = firstName && lastName ? `${firstName} ${lastName}` : '';

    const _onSubmit = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        const model = {
            changeTypeId,
            notes,
        };
        onSubmit && onSubmit(model);
    };

    const _onCancel = () => {
        onCancel && onCancel();
    };

    if (!isOpen) {
        return null;
    }

    const onChangeChangeTypeId = (value) => {
        if (value == ExperienceChangeType.InitialReview) {
            set_notes('Initial Review');
        } else {
            set_notes('');
        }
        set_changeTypeId(value);
    };

    return (
        <Dialog
            maxWidth='sm'
            open={isOpen}
            onClose={_onCancel}
            aria-labelledby='form-dialog-title'
        >
            <DialogContent>
                <div className='modal-container'>
                    <div className='modal-backdrop'></div>
                    <div
                        className='modal'
                        tabIndex={-1}
                        role='dialog'
                        style={{ width: '525px' }}
                    >
                        <div
                            className='modal-dialog'
                            role='document'
                        >
                            <form
                                name='levelChangeForm'
                                onSubmit={(event) => _onSubmit(event)}
                            >
                                <div>
                                    <div
                                        className='page-header'
                                        role='banner'
                                    >
                                        <h1 style={{ whiteSpace: 'nowrap' }}>Experience Modification</h1>
                                        <button
                                            type='button'
                                            className='close'
                                            data-dismiss='modal'
                                            aria-label='Close'
                                            onClick={_onCancel}
                                        >
                                            <span aria-hidden='true'>&times;</span>
                                        </button>
                                    </div>
                                    <div>
                                        <div
                                            style={styles.form}
                                            className={'standard-form'}
                                        >
                                            <div
                                                className='row'
                                                style={styles.formRow}
                                            >
                                                <div className='columns small-12 large-5'>
                                                    <label htmlFor='userId'>User</label>
                                                    <input
                                                        type='text'
                                                        disabled={true}
                                                        value={userFullName}
                                                    />
                                                </div>
                                            </div>
                                            <div
                                                className='row'
                                                style={styles.formRow}
                                            >
                                                <div className='columns small-12 large-5'>
                                                    <label htmlFor='changeTypeId'>
                                                        Modification Reason
                                                        <span className='req'>*</span>
                                                    </label>
                                                    <select
                                                        id={'changeTypeId'}
                                                        value={changeTypeId}
                                                        onChange={(e) => onChangeChangeTypeId(e.target.value)}
                                                        required={true}
                                                    >
                                                        {ExperienceChangeTypeOptions.sort(
                                                            (a, b) => a.sortOrder - b.sortOrder
                                                        ).map((fs) => {
                                                            return (
                                                                <option
                                                                    key={fs.id}
                                                                    value={fs.id}
                                                                >
                                                                    {fs.name}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                </div>
                                            </div>
                                            <div
                                                className='row'
                                                style={styles.formRow}
                                            >
                                                <div className='columns small-12 large-12'>
                                                    <label htmlFor='notes'>
                                                        Description and Explanation
                                                        <span className='req'>*</span>
                                                    </label>
                                                    <textarea
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        rows={3}
                                                        id='notes'
                                                        value={notes}
                                                        onChange={(e) => set_notes(e.target.value)}
                                                        required={true}
                                                        placeholder='Enter further description and explanation Notes...'
                                                        maxLength={400}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ padding: '5px 5px' }}>
                                        <div
                                            className='button-footer'
                                            style={styles.buttonContainer}
                                        >
                                            <button
                                                style={styles.buttonMarginRight}
                                                type='submit'
                                                className='button primary'
                                            >
                                                Submit
                                            </button>
                                            <button
                                                type='button'
                                                className='button hollow'
                                                data-dismiss='modal'
                                                onClick={_onCancel}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};
